var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRedDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.543 6.93555V16.9355H3.54297V6.93555H11.543ZM10.043 0.935547H5.04297L4.04297 1.93555H0.542969V3.93555H14.543V1.93555H11.043L10.043 0.935547ZM13.543 4.93555H1.54297V16.9355C1.54297 18.0355 2.44297 18.9355 3.54297 18.9355H11.543C12.643 18.9355 13.543 18.0355 13.543 16.9355V4.93555Z",
    fill: "#D32F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRedDelete);
export default __webpack_public_path__ + "static/media/icon-red-delete.3b6e58d14d3f89c70db53f30f15be860.svg";
export { ForwardRef as ReactComponent };